import StorageHandler from './StorageHandler.js';
import Dropdown from './Dropdown.js';

class Selection {
    constructor() {
        this.container = document.querySelector('.location-selection-container');

        if(this.container) {
            document.addEventListener('filterDataChanged', () => {
                this.buildButtonsFromSelectedElements();
            });
        }
    }

    buildButtonsFromSelectedElements() {
        const items = StorageHandler.instance.fetchData();

        this.container.innerHTML = '';

        items.forEach(item => {
            const button = document.createElement('div');

            button.className = 'selection-button';
            button.textContent = item.title;
            button.dataset.value = item.value;
            button.dataset.slug = item.slug;

            const removalBtn = document.createElement('span');
            removalBtn.className = 'cross';

            removalBtn.addEventListener('click', () => {
                button.remove();

                const event = new CustomEvent('dropdownInputChange', {
                    bubbles: true,
                    detail: {
                        checked: false,
                        title: item.title,
                        value: item.value,
                        slug: item.slug
                    }
                });
                document.dispatchEvent(event);

                // Uncheck it from the actual input
                const dropdown = new Dropdown();
                dropdown.uncheckItem(item.value, item.slug);

            });

            button.appendChild(removalBtn);

            this.container.appendChild(button);
        });
    }
}

export default Selection;
